import yup from "src/utils/yup/extensionMethods";

const integrations = yup.object().shape({
	name: yup.string().required()
});

const integrationSchema = (translate: Function) => yup.array().of(integrations).unique(translate("Títulos não podem ser repetidos"), (a: any) => a.name);

export default integrationSchema;
